import { HttpService } from 'app/services';
import * as AppActions from 'app/store/actions';
import { parseError } from 'helpers/Error';

export const CREATE_ROLE = '@ROLE/CREATE_ROLE';
export const CREATE_ROLE_SUCCESS = '@ROLE/CREATE_ROLE_SUCCESS';
export const CREATE_ROLE_FAIL = '@ROLE/CREATE_ROLE_FAIL';

export const CHANGE_ROLE_FORM = '@ROLE/CHANGE_ROLE_FORM';
export const CLEAR_CREATE_FORM = '@ROLE/CLEAR_CREATE_FORM';

export function createRole(name, initPermission) {
  return (dispatch) => {
    const permissions = initPermission.map((i) => {
      return {
        create: 0,
        read: 0,
        update: 0,
        delete: 0,
        menuCode: i?.menuCode,
        isAccessible: i?.isAccessible,
        entryPermissions: i?.entryPermissions.map((j) => {
          return {
            isAllowed: j.isAllowed,
            code: j.code,
          };
        }),
      };
    });

    const postData = {
      name,
      isChangeCommentRequired: true,
      permissions,
    };

    dispatch({ type: CREATE_ROLE });
    return HttpService.post(`api/roles`, postData)
      .then((resp) => {
        dispatch(
          AppActions.showMessage({
            message: 'role:ADD_ROLE_SUCCESS',
          }),
        );
        dispatch({ type: CREATE_ROLE_SUCCESS, payload: { roleId: resp.data.id } });
      })
      .catch((err) => {
        const { errorFields, errorMessages, errorTitle } = parseError(err);
        dispatch({
          type: CREATE_ROLE_FAIL,
          payload: { message: errorMessages.join('\n'), error: errorFields },
        });
        dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
      });
  };
}

export function clearCreateForm() {
  return (dispatch) => {
    dispatch({ type: CLEAR_CREATE_FORM });
  };
}

export function changeRoleCreateForm(data) {
  return (dispatch) => {
    dispatch({ type: CHANGE_ROLE_FORM, payload: { data } });
  };
}
